// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
import PermissionConstants from "../../../configs/PermissionConstants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import {
    InitialCompanyState,
    CompanySchema,
    FormFields,
} from "./Company.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import toast from "react-hot-toast";
import GoForm from "../../../components/Inputs/GoForm";
import GoLoader from "../../../common/GoLoader/GoLoader";
// Hooks
import usePermissions from "../../../hooks/usePermissions";

const Company = ({ id, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [company, setCompany] = useState(InitialCompanyState);

    const getCompany = async (id) => {
        spinService.on();
        const response = await get(EntityConstants.COMPANIES + `/${id}`);
        const data = await response.json();
        spinService.off();
        setCompany(data);
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewCompany = values.id === undefined;
        const url = isNewCompany ? EntityConstants.COMPANIES : EntityConstants.COMPANIES + `/${values.id}`;
        const method = isNewCompany ? post : put;
        const response = await method(url, { company: values });
        spinService.off();
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewCompany ? MessageContants.COMPANY_CREATED : MessageContants.COMPANY_UPDATED);
            onClose();
        }
    };

    useEffect(() => {
        if (id !== undefined) {
            getCompany(Number(id));
        }
    }, [id]);

    return (
        <React.Fragment>
            <Formik
                enableReinitialize
                initialValues={company}
                validationSchema={CompanySchema}
                onSubmit={(values) => handleSubmit(values)}
            >
                {({
                    values,
                    touched,
                    errors,
                    dirty,
                    isSubmitting,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                }) => (
                    <Form noValidate onSubmit={handleSubmit}>
                        <StyledDrawerForm>
                            <Grid
                                container
                                maxWidth="sm"
                                rowSpacing={1}
                                columnSpacing={{ xs: 1, sm: 2, md: 2 }}
                            >
                                {FormFields.map((formField, index) => {
                                    return (
                                        <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
                                            <GoForm
                                                config={formField}
                                                values={values}
                                                touched={touched}
                                                errors={errors}
                                                handleChange={handleChange}
                                            />
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Box sx={{ p: 2, textAlign: "right" }}>
                                <Button
                                    variant="contained"
                                    color="error"
                                    startIcon={<Iconify icon="eva:close-circle-outline" />}
                                    onClick={() => onClose()}
                                >
                                    Close
                                </Button>
                                &nbsp;&nbsp;
                                {
                                    ((values.id === undefined && permissions.has(PermissionConstants.COMPANY_CREATE)) || (values.id !== undefined && permissions.has(PermissionConstants.COMPANY_UPDATE))) &&
                                    <Button
                                        variant="contained"
                                        startIcon={<Iconify icon="eva:save-fill" />}
                                        type="submit"
                                    >
                                        {values.id === undefined ? 'Save' : 'Update'}
                                    </Button>}
                            </Box>
                        </StyledDrawerForm>
                    </Form>
                )}
            </Formik>
        </React.Fragment>
    );
};

Company.propTypes = {
    id: PropTypes.number,
    onClose: PropTypes.any,
};

export default Company;
